<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All Disputes</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <all-disputes-table />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * View Fixed Deposit Component
 */

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import AllDisputesTable from "@/components/Kleyton/Tables/Dispute/AllDisputesTable";

export default {
  name: "AllDisputes",
  page: {
    title: "All Disputes",
    meta: [{ name: "All Disputes", content: window.__env.app.description }]
  },
  components: {
    AllDisputesTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "All Disputes",

      items: [
        {
          text: "Disputes",
          href: "/"
        },
        {
          text: "All Disputes",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
